import { render, staticRenderFns } from "./NotePaymentpopup.vue?vue&type=template&id=057039b8&scoped=true"
import script from "./NotePaymentpopup.vue?vue&type=script&lang=js"
export * from "./NotePaymentpopup.vue?vue&type=script&lang=js"
import style0 from "./NotePaymentpopup.vue?vue&type=style&index=0&id=057039b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057039b8",
  null
  
)

export default component.exports